export const blockIconsAndroidSignalDisconnectedNew = (
	<span className='material-symbols-outlined'>signal_disconnected</span>
);
